import { FC, lazy, useMemo } from 'react';

import { LoadingScreen } from '@/components';
import { useAuth } from '@/hooks';
import { APP_ROUTES } from '@/routes';

import { ProtectedRouteProps } from './types';

const RedirectPage = lazy(() => import('@/pages/RedirectPage'));

export const ProtectedRoute: FC<ProtectedRouteProps> = ({ paywallData, children }) => {
  const auth = useAuth();

  const hasAccess = useMemo(() => {
    if (!paywallData) {
      return true;
    }

    return paywallData.Pages.some((page) => {
      const [_, pageUrl] = page.split('#');
      return APP_ROUTES.dataManagement === pageUrl;
    });
  }, [paywallData]);

  if (!auth.isAuthenticated) {
    return <LoadingScreen />;
  }

  if (!hasAccess) {
    return <RedirectPage redirectLink={paywallData!.RedirectUrl} />;
  }

  return children;
};
